import "./scss/DropdownMenuShortcode.scss";
Array.from(document.getElementsByClassName('DropdownMenuShortcode')).forEach(function (element) {
    element.setAttribute('tabindex', '0');
});
